export default {
  customized: 'Customized',
  noMatches: 'No components found',
};
